export default {
  sm: 768,
};
